import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _t from "../models/identifier.js";
import { getByteLength as er } from "../util/string-utils.js";
import ti from "../models/push-token.js";
import { logger as E, IndexedDBAdapter as et } from "../../shared-lib/index.js";
import { STORAGE_KEYS as s } from "../managers/storage-manager.js";
import { User } from "../User/index.js";
var bt = /*#__PURE__*/function () {
  function bt(t, s) {
    _classCallCheck(this, bt);
    this.h = t, this.j = s, this.h = t, this.j = s;
  }
  _createClass(bt, [{
    key: "getUserId",
    value: function getUserId() {
      var t = this.j.tu(s.iu.su);
      if (null == t) return null;
      var i = t.eu,
        e = er(i);
      if (e > User.mr) {
        for (; e > User.mr;) i = i.slice(0, i.length - 1), e = er(i);
        t.eu = i, this.j.uu(s.iu.su, t);
      }
      return i;
    }
  }, {
    key: "ou",
    value: function ou(t) {
      var i = null == this.getUserId();
      this.j.uu(s.iu.su, new _t(t)), i && this.j.ru(t);
    }
  }, {
    key: "setCustomUserAttribute",
    value: function setCustomUserAttribute(t, s) {
      if (this.h.hu(t)) return E.info('Custom Attribute "' + t + '" is blocklisted, ignoring.'), !1;
      var i = {};
      return i[t] = s, this.nu(User.lu, i, !0);
    }
  }, {
    key: "nu",
    value: function nu(t, s) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var e = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      var u = this.j.mu(this.getUserId(), t, s);
      var o = "",
        r = t,
        h = s;
      return i && (o = " custom", "object" == typeof s && (r = Object.keys(s)[0], h = s[r], "object" == typeof h && (h = JSON.stringify(h, null, 2)))), !e && u && E.info("Logged".concat(o, " attribute ").concat(r, " with value ").concat(h)), u;
    }
  }, {
    key: "Pn",
    value: function Pn(t, i, e, u, o) {
      this.nu("push_token", t, !1, !0), this.nu("custom_push_public_key", e, !1, !0), this.nu("custom_push_user_auth", u, !1, !0), this.nu("custom_push_vapid_public_key", o, !1, !0);
      var r = et.Us.Rs,
        h = new et(r, E),
        n = new ti(t, i, e, u, o);
      this.j.ft(s.ct.In, n.dt()), h.setItem(r.Fs.cu, r.me, !0);
    }
  }, {
    key: "Sn",
    value: function Sn(t) {
      if (this.nu("push_token", null, !1, !0), this.nu("custom_push_public_key", null, !1, !0), this.nu("custom_push_user_auth", null, !1, !0), this.nu("custom_push_vapid_public_key", null, !1, !0), t) {
        var _t2 = et.Us.Rs,
          i = new et(_t2, E);
        this.j.ft(s.ct.In, !1), i.setItem(_t2.Fs.cu, _t2.me, !1);
      }
    }
  }]);
  return bt;
}();
export { bt as default };